import "@/styles/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import bfeSensors from "@cttq/bfe-sensors-ts";
const sensorsConfig = bfeSensors.SensorsConfig.init({
	project: "cttq-navigation",
	projectName: "天晴导航页",
	runEnv: import.meta.env.VITE_NODE_ENV, // 运行环境
	projectId: "cttq-navigation", // 项目ID
	personInfo: { personCode: "999999999" } // 人的基础信息，需要从Store中获取
});
const app = createApp(App);
sensorsConfig.configSensors();

app.use(createPinia());
app.use(router);
app.use(bfeSensors, sensorsConfig);
app.mount("#app");
